// extracted by mini-css-extract-plugin
export default {"root":"styles_root__fC7Nj","svg":"styles_svg__1l5oL"};